import { GetCurrencyFullName } from '../../utils/Currency';
import { GetFloatNumber, GetNumberToWords } from '../../utils/NumberFormatter';

function InvoiceBreakdownSection({ info }) {
    const invoice = info?.invoice;
    const paymentInstruction = info?.paymentInstruction || '';

    const createMarkup = () => {
        return { __html: invoice?.comment?.replace(/\n/g, '<br>') };
    };
    const paymentMarkup = () => {
        return { __html: paymentInstruction.replace(/\n/g, '<br>') };
    };

    return (
        <div className="mx-5 mb-6 print:mx-0 print:mb-4 print:break-inside-avoid print:page-break-inside-avoid">
            <div className="overflow-hidden print:break-inside-avoid ">
                <div className="flex print:break-inside-avoid justify-between items-start">
                    {/* Comments Section - Left */}
                    <div className=" print:break-inside-avoid ">
                        <div className="rounded-lg px-4 py-3 bg-invoice-light w-[246px] *:text-xs2">
                            {invoice?.comment?.length > 0 ? (
                                <div
                                    className="text-xs2 text-invoice-primary mb-4.5"
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={createMarkup()}
                                />
                            ) : null}
                            <div className="leading-[18px] text-invoice-primary">
                                <span>Payment Instruction:</span>
                                <br />
                                <div
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={paymentMarkup()}
                                />
                            </div>
                        </div>

                        <div>
                            {invoice?.noteDescription && (
                                <p className="mt-3 text-invoice-secondary italic text-xs2">
                                    * {invoice?.noteDescription}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* Calculations Section - Right */}
                    <div className="w-[220px] print:break-inside-avoid text-xs2">
                        <div className="w-full flex flex-col gap-2.5">
                            <div className="flex justify-between w-full bg-invoice-light rounded-lg px-3 py-2">
                                <span>Total</span>
                                <span>
                                    {/* {GetCurrencySymbol(invoice?.currency)} */}
                                    {GetFloatNumber(invoice?.amountBilled || 0)}
                                </span>
                            </div>
                            <div className="flex justify-between w-full bg-invoice-light rounded-lg px-3 py-2">
                                <span>VAT</span>
                                <span>{GetFloatNumber(invoice?.vatAmount || 0)}</span>
                            </div>
                            <div className="flex justify-between w-full bg-invoice-dark-gray text-white  rounded-lg px-3 py-2">
                                <span>Grand Total</span>
                                <span>{GetFloatNumber(invoice?.amountBilled || 0)}</span>
                            </div>
                            <div className="flex flex-col text-right">
                                <span className="text-invoice-secondary text-xs2">
                                    Amount in words:
                                </span>
                                <span className="text-xs2 text-invoice-primary mt-px capitalize">
                                    {GetNumberToWords(invoice?.amountBilled || 0)}{' '}
                                    {GetCurrencyFullName(invoice?.currency)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvoiceBreakdownSection;
